import { emailTemplateApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { INCLUDE_OPTIONS_MAP } from 'constants/emailTemplates';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const EMAIL_TEMPLATE_CATEGORIES_TYPE = createNamedActions('emailTemplateCategories', {
  GET_CATEGORIES: 'GET_CATEGORIES',
  ADD_CATEGORY: 'ADD_CATEGORY',
  REMOVE_CATEGORY: 'REMOVE_CATEGORY',
});

const emailTemplateCategories = new schema.Entity(
  'emailTemplateCategories',
  {},
  { idAttribute: 'id' },
);

export const getEmailTemplateCategoriesAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await emailTemplateApi.getCategories({
    include: INCLUDE_OPTIONS_MAP.CATEGORY_TEMPLATES,
    skipForbiddenError: true,
  });

  return dispatch({
    type: EMAIL_TEMPLATE_CATEGORIES_TYPE.GET_CATEGORIES,
    payload: normalize(data, [emailTemplateCategories]).entities.emailTemplateCategories,
  });
});

export const addEmailTemplateCategoryAction = catchAsyncActionError(body => async dispatch => {
  const { data } = await emailTemplateApi.createCategory(body);

  return dispatch({
    type: EMAIL_TEMPLATE_CATEGORIES_TYPE.ADD_CATEGORY,
    payload: data,
  });
});

export const removeEmailTemplateCategoryAction = catchAsyncActionError(params => async dispatch => {
  await emailTemplateApi.deleteCategory(params);

  return dispatch({
    type: EMAIL_TEMPLATE_CATEGORIES_TYPE.REMOVE_CATEGORY,
    meta: params,
  });
});
